/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamLangUpdateViewModel } from "../types/ExamLangUpdateViewModel.ts";

export const examLangUpdateViewModelSchema = z.object({
  cultureInfo: z
    .string()
    .describe(
      "Código de cultura do idioma a ser atualizado (ex: pt-BR, en-US).",
    )
    .nullish(),
  instruction: z
    .string()
    .describe(
      "Instrução ou descrição do idioma de prova exibida ao aluno. Opcional.",
    )
    .nullish(),
  active: z.optional(
    z
      .boolean()
      .describe("Define se o idioma de prova estará ativo após a atualização."),
  ),
}) as unknown as ToZod<ExamLangUpdateViewModel>;
